import React from 'react';
import notificationIcon from './notificationIcon.svg';
import {Image} from '@learningblocks/storybook-components';

export function DescriptionIcon() {
  return <Image alt='info' tabIndex={-1} src={notificationIcon} />;
}
